import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { getImage } from '@utils/imageHelper';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledAvatar = styled.img`
  cursor: default;
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  border-radius: 50%;
`;

const UserAvatar = styled(StyledAvatar)`
  border: 2px solid var(--color-i-white);
  margin: 0px -16px;
  position: relative;
  z-index: 2;
`;

const AvatarGroup = () => {
  const userImage = useSelector(({ auth }) => auth.me?.thumbnail);
  return (
    <Wrapper>
      <StyledAvatar
        $size="40px"
        src={getImage('combat/male-avatar.svg')}
        alt="generic male"
      />
      <UserAvatar $size="60px" src={userImage} alt="profile pic" />
      <StyledAvatar
        $size="40px"
        src={getImage('combat/female-avatar.svg')}
        alt="generic female"
      />
    </Wrapper>
  );
};

export default AvatarGroup;
